import { render, staticRenderFns } from "./boughtPrint.vue?vue&type=template&id=67aed928&scoped=true"
import script from "./boughtPrint.vue?vue&type=script&lang=js"
export * from "./boughtPrint.vue?vue&type=script&lang=js"
import style0 from "./boughtPrint.vue?vue&type=style&index=0&id=67aed928&prod&scoped=true&lang=less"
import style1 from "./boughtPrint.vue?vue&type=style&index=1&id=67aed928&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aed928",
  null
  
)

export default component.exports